export default __webpack_public_path__ + "static/media/SansTimesSans@24R.bffcb384.ttf";